module.exports = __webpack_public_path__ + "static/media/reset-inex.7ff0609e.svg";